import { useEffect, useRef } from "react";
import { validate, formatPhone } from "./steps";

const inputCls = "w-full bg-transparent border-b border-white/20 focus:border-[#D4AF5A] outline-none py-4 text-xl sm:text-2xl text-[#F5F3EE] placeholder:text-[#A7A7AD]/60 transition-colors";

export const StepField = ({ step, index, answers, set, error, onNext }) => {
  const ref = useRef(null);
  const v = answers[step.key] || "";
  useEffect(() => {
    if (window.matchMedia("(pointer: fine)").matches) ref.current?.focus();
  }, [step.key]);
  const submit = (e) => { e.preventDefault(); onNext(validate(step, answers)); };
  const showExtra = step.extra && (!step.extra.when || v === step.extra.when);

  return (
    <form id="briefing-step-form" onSubmit={submit} noValidate>
      <p className="font-mono text-xs text-gold mb-4">{String(index + 1).padStart(2, "0")} {step.required ? "· obrigatório" : "· opcional"}</p>
      <label htmlFor={`f-${step.key}`} className="block font-display text-3xl sm:text-5xl font-semibold leading-[1.05] tracking-[-0.03em] mb-10">{step.q}</label>

      {step.type === "choice" && (
        <div className="grid sm:grid-cols-2 gap-3" role="radiogroup">
          {step.options.map((o) => (
            <button type="button" key={o} role="radio" aria-checked={v === o} onClick={() => set(step.key, v === o && !step.required ? "" : o)} data-testid={`briefing-option-${o.toLowerCase().replace(/\s+/g, "-")}`}
              className={`min-h-14 px-5 py-3 rounded-2xl text-left text-[15px] border transition-[background-color,border-color,color] duration-300 ${v === o ? "bg-[#D4AF5A]/10 border-[#D4AF5A] text-[#F5F3EE]" : "border-white/10 text-[#F5F3EE]/80 hover:border-white/30"}`}>
              {o}
            </button>
          ))}
        </div>
      )}
      {step.type === "textarea" && (
        <textarea id={`f-${step.key}`} ref={ref} rows={4} value={v} onChange={(e) => set(step.key, e.target.value)} placeholder={step.placeholder} data-testid={`briefing-input-${step.key}`} className={`${inputCls} text-lg sm:text-xl resize-none`} />
      )}
      {(step.type === "text" || step.type === "tel") && (
        <input id={`f-${step.key}`} ref={ref} type={step.type} inputMode={step.type === "tel" ? "tel" : undefined} autoComplete={step.type === "tel" ? "tel" : step.key === "nome" ? "name" : "organization"}
          value={v} onChange={(e) => set(step.key, step.type === "tel" ? formatPhone(e.target.value) : e.target.value)} placeholder={step.placeholder} data-testid={`briefing-input-${step.key}`} className={inputCls} />
      )}
      {showExtra && (
        <input type={step.extra.when ? "url" : "text"} value={answers[step.extra.key] || ""} onChange={(e) => set(step.extra.key, e.target.value)} placeholder={step.extra.placeholder} data-testid={`briefing-input-${step.extra.key}`} className={`${inputCls} mt-6 text-lg`} />
      )}
      <p role="alert" data-testid="briefing-error" className={`mt-5 text-sm text-[#e8a87c] min-h-5 ${error ? "" : "invisible"}`}>{error || "."}</p>
      <button type="submit" className="hidden" aria-hidden="true" tabIndex={-1} />
    </form>
  );
};
